import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

const CAROUSEL_SELECTOR = '.js-carousel-effect'
const PREV_BUTTON_SELECTOR = '.js-carousel-effect-prev'
const NEXT_BUTTON_SELECTOR = '.js-carousel-effect-next'

function initSwiper(element) {
  const swiperElement = element.querySelector('.swiper')
  if (!swiperElement) return
  new Swiper(swiperElement, {
    effect: 'cards',
    slidesPerView: 1,
    navigation: {
      prevEl: element.querySelector(PREV_BUTTON_SELECTOR),
      nextEl: element.querySelector(NEXT_BUTTON_SELECTOR)
    },
    cardsEffect: {
      rotate: false,
      perSlideOffset: 10
    },
    loop: true,
    loopAdditionalSlides: 1,
    centeredSlides: true,
  })
}

export function initCarouselEffectSwipers() {
  document.querySelectorAll(CAROUSEL_SELECTOR).forEach(initSwiper)
}
